<template>
  <div class="fccPublicacoes">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            addFilter
            :items="listagemPublicacao"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          >
          </fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="addFieldModal"
      titleModal="Novo tipo de publicação"
      escondeFooter
      travaEsc
      size="lg"
      travaBack
    >
      <form
        @submit.prevent="criar.idpublictipo === 0 ? criarPublicacao() : editarPublicacao()"
        autocomplete="off"
      >
        <div class="my-2">
          <div class="row">
            <div class="col-sm-12 my-2">
              <label>Nome</label>
              <b-form-input
                v-model="criar.dstipo"
                placeholder="Tipo de Publicação"
                required
              ></b-form-input>
            </div>
          </div>
          <div class="row my-2">
            <div class="col-sm-12">
              <div class="publicaBox">
                <span class="titlePublicaBox">Tipo de Publicação</span>
                <div class="row">
                  <div class="col-sm-6 datas">
                    Horário
                    <datetime
                      value-zone="America/Sao_Paulo"
                      input-id="horaInicial"
                      type="time"
                      v-model="criar.horarioiniciopadrao"
                      placeholder="HH:mm"
                      class="form-control my-2"
                    ></datetime>
                  </div>
                  <div class="col-sm-6 datas">
                    Horário
                    <datetime
                      value-zone="America/Sao_Paulo"
                      input-id="horaFinal"
                      type="time"
                      placeholder="HH:mm"
                      v-model="criar.horariofimpadrao"
                      class="form-control my-2"
                    ></datetime>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-4">
              <div>Possui formulário</div>
              <toggle-button
                v-model="criar.possuiformulario"
                @change="changePagamento"
                :sync="true"
              />
            </div>
            <div class="col-sm-4">
              <div>Chave obrigátoria</div>
              <toggle-button
                :disabled="!this.criar.possuiformulario"
                v-model="criar.chaveobrigatoria"
                @change="changePagamento"
                :sync="true"
              />
            </div>
            <div class="col-sm-4">
              <div>Possui pagamento</div>
              <toggle-button
                v-model="criar.possuipagamento"
                @change="changePagamento"
                :sync="true"
              />
            </div>
          </div>
          <div class="row innerPage space configuracoes" v-if="criar.idpublictipo > 0">
            <div class="col-sm-12">
              <fccTable
                striped
                hover
                :fields="fieldsParam"
                :orderby="sortBy"
                addFilter
                addFunction="addParam"
                :items="listagemParamentos"
                responsive
                :actions="actionsParam"
                :porPage="itemPorPage"
                search
                modal
                pagination
                fieldVisibility
                pdf
                csv
                xls
                :titlePage="titlePage"
                :titlePDF="titlePDF"
              >
              </fccTable>
            </div>
            <hr />
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
    <fccModal
      centered
      idModal="editFieldModal"
      titleModal="Parâmetros"
      escondeFooter
      travaEsc
      size="lg"
      travaBack
    >
      <form
        @submit.prevent="
          parametros.idpublicacaoparametropadrao === 0 ? adicionandoParam() : editandoParam()
        "
        autocomplete="off"
      >
        <div class="row">
          <div class="col-sm-12 my-2">
            <label>Parâmetro</label>
            <b-form-input
              v-model="parametros.parametro"
              placeholder="Tipo de Publicação"
              required
            ></b-form-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 my-2">
            <label>Código único</label>
            <b-form-input
              v-model="parametros.codigo"
              placeholder="Código único"
              required
            ></b-form-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 my-2">
            <label>Tipo de parâmetro</label>
            <v-select
              @input="mudaBit"
              :options="opcoesParam"
              v-model="tipoparametro"
              placeholder="Selecione o tipo"
              class="selectSPI"
              label="tipoparametro"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!tipoparametro"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
        </div>

        <div class="row my-2" v-if="tipoparametro.tipoparametro">
          <div class="col-sm-12">
            <label>Valor padrão</label>
            <br />
            <fccInput
              extraClasses="inputLabel"
              v-if="
                tipoparametro.tipoparametro.toLowerCase() === 'varchar' ||
                tipoparametro.tipoparametro.toLowerCase() === 'int'
              "
              v-model="parametros.valorpadrao"
              required
              :type="tipoparametro.tipoparametro.toLowerCase() === 'int' ? 'number' : 'text'"
              >Valor padrão <span>*</span></fccInput
            >
            <span
              class="datetimeShow"
              v-if="tipoparametro.tipoparametro.toLowerCase() === 'datetime'"
              ><datetime
                value-zone="America/Sao_Paulo"
                type="date"
                format="dd/MM/yyyy"
                class="form-control"
                placeholder="__/__/____"
                v-model="parametros.valorpadrao"
                required
              ></datetime
            ></span>
            <span v-if="tipoparametro.tipoparametro.toLowerCase() === 'bit'"
              ><toggle-button v-model="parametros.valorpadrao" :sync="true"
            /></span>
          </div>
        </div>
        <div class="row my-4">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import './assets/sass/fccPublicacoes.scss'
import './assets/sass/fccPublicacoesConfig.scss'

export default {
  data() {
    return {
      sortBy: 'idpublicacaoparametropadrao',
      titlePage: 'Tipos de publicações',
      titlePDF: 'Lista de Tipos de publicações',
      baseUrlPublicacao: '',
      itemPorPage: '100',
      tipoparametro: {},
      listagemParamentos: [],
      opcoesParam: [],
      parametros: {},
      form: [],
      listagemPublicacao: [],
      criar: {
        idpublictipo: 0,
        horarioiniciopadrao: '10:00',
        horariofimpadrao: '14:00',
        dstipo: '',
        possuiformulario: false,
        possuipagamento: false,
        chaveobrigatoria: false
      },
      fieldsParam: [
        { key: 'idpublicacaoparametropadrao', label: 'ID', sortable: true, active: true },
        { key: 'parametro', label: 'Parâmetro', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ],
      fields: [
        { key: 'dstipo', label: 'Tipo', sortable: true, active: true },
        { key: 'horarioiniciopadrao', label: 'Horário Início', sortable: true, active: true },
        { key: 'horariofimpadrao', label: 'Horário Final', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ],
      actionsParam: [
        {
          button: true,
          funcaoButton: 'editParam',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteParam',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ]
    }
  },
  methods: {
    changePagamento() {
      if (!this.criar.possuiformulario) {
        this.criar.chaveobrigatoria = false
      }
    },
    bolleanChange: function (bolleanB) {
      if (bolleanB === '0') {
        return false
      } else if (bolleanB === '1') {
        return true
      } else if (bolleanB === true) {
        return '1'
      } else if (bolleanB === false) {
        return '0'
      } else {
        return bolleanB
      }
    },
    listandoParametroTipo: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao + 'PublicacaoParametroPadraoTipo/Listar',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.opcoesParam = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listandoPublicacoes: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao + 'PublicacaoTipo/ListarPublicacaoTipo',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemPublicacao = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listandoPublicacoesParametro: function (id) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlPublicacao + 'PublicacaoParametroPadrao/Listar/' + id,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemParamentos = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.criar = {}
      this.criar.idpublictipo = 0
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    addParam: function () {
      this.parametros = {}
      this.tipoparametro = ''
      this.parametros.idpublicacaoparametropadrao = 0
      this.$root.$emit('bv::show::modal', 'editFieldModal')
    },
    editParam: function (_, item) {
      this.parametros = { ...item }
      this.tipoparametro = {
        idpublicacaoparametrotipo: this.parametros.idpublicacaoparametrotipo,
        tipoparametro: this.parametros.tipoparametro
      }
      this.parametros.valorpadrao = this.verificaBit()
      this.$root.$emit('bv::show::modal', 'editFieldModal')
    },
    editField: function (_, item) {
      this.criar = { ...item }
      this.$root.$emit('bv::show::modal', 'addFieldModal')
      this.listandoPublicacoesParametro(item.idpublictipo)
    },
    mudaBit: function () {
      this.parametros.valorpadrao = ''
    },
    verificaBit: function () {
      return this.tipoparametro.tipoparametro.toLowerCase() === 'bit'
        ? this.bolleanChange(this.parametros.valorpadrao)
        : this.parametros.valorpadrao
    },
    montaParam: function (edit = false) {
      return {
        idPublicacaoParametroPadrao: edit ? this.parametros.idpublicacaoparametropadrao : 0,
        idPublicTipo: this.criar.idpublictipo,
        idPublicacaoParametroTipo: this.tipoparametro.idpublicacaoparametrotipo,
        parametro: this.parametros.parametro,
        codigo: this.parametros.codigo,
        valorPadrao: this.verificaBit(),
        ordem: 0
      }
    },
    editandoParam: function () {
      const hparametros = this.montaParam(true)
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlPublicacao + 'PublicacaoParametroPadrao/AlterarPublicacaoParametroPadrao',
          hparametros,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoPublicacoesParametro(this.criar.idpublictipo)
          this.$root.$emit('bv::hide::modal', 'editFieldModal')
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    adicionandoParam: function () {
      const hparametros = this.montaParam()
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoParametroPadrao/InserirPublicacaoParametroPadrao',
          hparametros,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoPublicacoesParametro(this.criar.idpublictipo)
          this.$root.$emit('bv::hide::modal', 'editFieldModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    deleteParam: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.parametro).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlPublicacao +
                'PublicacaoParametroPadrao/Excluir/' +
                item.idpublicacaoparametropadrao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoPublicacoesParametro(item.idpublictipo)
              this.callToast(this.mensagensUpdate.excluido)
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto())
        }
      })
    },
    deleteField: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.dstipo).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlPublicacao +
                'PublicacaoTipo/ExcluirPublicacaoTipo?id=' +
                item.idpublictipo +
                '&idPublicTipoHoraPadrao=' +
                item.idpublictipohorapadrao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoPublicacoes()
              this.callToast(this.mensagensUpdate.excluido)
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto())
        }
      })
    },
    criarPublicacao: function () {
      if (this.criar.horariofimpadrao < this.criar.horarioiniciopadrao) {
        this.callAlert(
          'Erro ao Inserir',
          'Horário Final menor que a Horário inicial',
          'error',
          'error'
        )
      } else {
        this.carregaTexto(this.codeMensagem('C03'))
        this.criar.horarioiniciopadrao = this.getHourSGP(this.criar.horarioiniciopadrao)
        this.criar.horariofimpadrao = this.getHourSGP(this.criar.horariofimpadrao)
        axios
          .post(
            this.baseUrlPublicacao + 'PublicacaoTipo/InserirPublicacaotipo',
            this.criar,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoPublicacoes()
            this.$root.$emit('bv::hide::modal', 'addFieldModal')
            this.callToast(this.mensagensUpdate.adicionado)
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto())
      }
    },
    editarPublicacao: function () {
      if (this.criar.horariofimpadrao < this.criar.horarioiniciopadrao) {
        this.callAlert(
          'Erro ao Inserir',
          'Horário Final maior que a Horário inicial',
          'error',
          'error'
        )
      } else {
        this.carregaTexto(this.codeMensagem('C03'))
        this.criar.horarioiniciopadrao = this.getHourSGP(this.criar.horarioiniciopadrao)
        this.criar.horariofimpadrao = this.getHourSGP(this.criar.horariofimpadrao)
        axios
          .put(
            this.baseUrlPublicacao + 'PublicacaoTipo/AlterarPublicacaoTipo',
            this.criar,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoPublicacoes()
            this.$root.$emit('bv::hide::modal', 'addFieldModal')
            this.callToast(this.mensagensUpdate.editado)
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto())
      }
    }
  },
  mounted: function () {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.listandoPublicacoes()
    this.listandoParametroTipo()
  }
}
</script>
